module.exports = __webpack_public_path__ + "img/main_gachita.bbc1ee72.png";